import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import StartPage from './components/StartPage';
import MultiplayerLobby from './components/MultiplayerLobby';
import RemoteGame from './components/RemoteGame';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from './utils/analytics';
import FaqPage from './components/FaqPage';

function App() {
  function AnalyticsListener() {
    const location = useLocation();
    useEffect(() => {
      trackPageview(location.pathname + location.search);
    }, [location.pathname, location.search]);
    return null;
  }
  return (
    <Router basename='/heist'>
      <AnalyticsListener />
      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/game" element={<RemoteGame />} />
        <Route path="/multiplayer" element={<MultiplayerLobby />} />
        <Route path="/faq" element={<FaqPage />} />
        {/* The multiplayer route will be added later */}
      </Routes>
    </Router>
  );
}

export default App;
